import React from "react";
import outlook from "./Assets/outlook.png";
import gmail from "./Assets/gmail.png";
import word from "./Assets/word.png";
import wApp from "./Assets/wApp.png";
import LN from "./Assets/LN.png";
import chrome from "./Assets/chrome.png";
import CRM from "./Assets/CRM.png";
import report from "./Assets/report.png";

const apps = [
  { icon: outlook, title: "Outlook", desc: "Long emails by voice" },
  { icon: gmail, title: "Gmail", desc: "Reply in seconds" },
  { icon: word, title: "Word", desc: "Draft without typing" },
  { icon: wApp, title: "WhatsApp Web", desc: "Faster replies" },
  { icon: LN, title: "LinkedIn", desc: "Sharper pro messages" },
  { icon: chrome, title: "Chrome", desc: "Any web field" },
  { icon: CRM, title: "CRM & tickets", desc: "Notes & responses" },
  { icon: report, title: "Admin & reports", desc: "Spoken thoughts, clean text" },
];

const AppsSection = () => {
  return (
    <section className="w-full max-w-[1180px] mx-auto md:px-7 px-4 flex flex-col gap-8">
      <div className="flex flex-col gap-3 items-center md:items-start">
        <h2 className="font-jakarta font-extrabold text-[#0F1B2D] text-center md:text-left text-[2rem] sm:text-[2.4rem] md:text-[2.875rem] leading-[1.24] tracking-[-0.02em]">
          <span className="bg-clip-text text-transparent bg-gradient-to-r from-[#3AB1F6] to-[#407BFF]">
            One voice.
          </span>{" "}
          Every Windows app.
        </h2>
        <p className="font-inter font-normal text-[#33425A] text-center md:text-left text-[1rem] sm:text-[1.125rem] md:text-[1.3125rem] leading-[1.5] max-w-[680px]">
          Zero Typing types into whatever's in front of you — the apps you
          already live in all day.
        </p>
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4">
        {apps.map((a, i) => (
          <div
            key={i}
            className="bg-[#F9F9F9] border border-[#0000000D] rounded-2xl p-4 flex items-center gap-3"
          >
            <img
              src={a.icon}
              alt={a.title}
              className="w-10 h-10 object-contain shrink-0"
            />
            <div className="flex flex-col">
              <span className="font-inter font-semibold text-[#0F1B2D] text-[0.95rem] leading-tight">
                {a.title}
              </span>
              <span className="font-inter font-normal text-[#33425A] text-[0.8125rem] leading-tight mt-1">
                {a.desc}
              </span>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default AppsSection;
